// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateSelectDomainValue = (property, value) => ({
    property,
    type: actions.UPDATE_RGA_SEARCH_SELECT_DOMAIN_VALUE,
    value
});

export const resetRgaSearchSelectedDomains = () => ({
    type: actions.RESET_RGA_SEARCH_FORM_SELECTED_DOMAINS
});




// WEBPACK FOOTER //
// ./src/rga/search/action-creators/select-domains.js